import { FC, PropsWithChildren, ReactElement } from 'react'

import './SidebarPageWrapper.scss'

interface SidebarPageWrapperProps extends PropsWithChildren {
    className?: string;
}

const SidebarPageWrapper: FC<SidebarPageWrapperProps> = ({
    className = '',
    children,
}): ReactElement => (
    <div className={`sidebar-page-wrapper ${className}`}>
        {children}
    </div>
)

export default SidebarPageWrapper
